import React from "react";

import Tooltip from "core/Tooltip";
import { Button, IconDetailsText } from "./styles";

const PhotoDetails = () => (
    <Tooltip
        darkMode
        message={
            <div>
                <IconDetailsText>
                    Public Domain icons can be downloaded and used however you
                    like. And just like a royalty–free purchase, you can edit
                    them.
                </IconDetailsText>
                <a
                    href="https://creativecommons.org/publicdomain/zero/1.0/"
                    target="_blank"
                >
                    Learn more
                </a>
            </div>
        }
    >
        <Button>Public Domain</Button>
    </Tooltip>
);

export default PhotoDetails;
